export default __webpack_public_path__ + "static/media/roadmap8.44eecfc4.png";